export default __webpack_public_path__ + "static/media/node.94e10efa.png";